import {useParams} from 'react-router-dom';
import ImageCarousel from '../../../components/imageCarousel';
import ShareTitleHeader from '../../../components/mazraeKit/headers/shareTitleHeader';
import PageLoader from '../../../components/pageLoader';
import SimilarProducts from '../../../module/newShop/productDetail';
import useGetSubBrandDetailById from '../../../services/hookService/getSubBrandDetailById/useGetSubBrandDetailById';
import {DescriptionView} from '../CategoryCardDetail/descriptionView';
import DetailTable from './DetailTable';
import SaleAgents from './SaleAgents';

const ProductDetail = () => {
  const {subBrandId} = useParams();

  const {data, isLoading} = useGetSubBrandDetailById(subBrandId);

  const imagesUrl = data?.images?.map(
    item =>
      item.image || item.image_128 || item.image_330 || item.image_1024 || '',
  );

  if (isLoading) return <PageLoader />;

  return (
    <div className="flex flex-col w-full h-full">
      <ShareTitleHeader title={data?.name} hideShareIcon={true} />

      <div className="flex flex-col w-full h-full gap-4 overflow-y-auto">
        <div className="px-4 pt-4">
          <ImageCarousel
            images={imagesUrl ?? []}
            autoPlay={true}
            interval={4000}
            showDots={true}
            showArrows={true}
          />
        </div>
        <h5 className="flex w-full px-4 text-gray-800 text-md">
          {data?.advertisement_title}
        </h5>
        <div className="flex items-center justify-between w-full px-4">
          <span className="text-gray-700 text-md">قیمت:</span>
          <span className="text-xl">
            {data?.ad_price ? `${data?.ad_price?.toLocaleString()} تومان` : '-'}
          </span>
        </div>
        <div className="flex items-center w-full gap-4 px-4 overflow-x-auto "></div>

        <DetailTable data={data!} />

        {(data?.advertisement_description ||
          data?.additional_data?.combinations ||
          data?.additional_data?.application_method) && (
          <DescriptionView
            data={{
              description: data?.advertisement_description ?? '',
              combinations: data?.additional_data?.combinations ?? '',
              application_method:
                data?.additional_data?.application_method ?? '',
            }}
          />
        )}

        <SaleAgents />

        <hr className="mx-4 text-gray-300" />

        {data?.id && <SimilarProducts subBrandId={data?.id} />}
      </div>
    </div>
  );
};

export default ProductDetail;
